import { useLocation, useNavigate } from 'react-router-dom';

import { ProfileUsers } from '../../../../../../api/enumerations';
import { REDE_PROTO_BASE, SUBNAV } from '../../../../../../constants/redeProto';
import { useCurrentRole } from '../../../../../../hooks/useCurrentRole';
import { Nav, NavItem } from './styles';

export function SubNav(): JSX.Element {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const role = useCurrentRole();

  const isAdmin =
    role === ProfileUsers.ADMIN || role === ProfileUsers.BANK_ADMIN;
  const items = SUBNAV.filter((item) => !item.adminOnly || isAdmin);

  const isActive = (path: string): boolean => {
    const target = path ? `${REDE_PROTO_BASE}/${path}` : REDE_PROTO_BASE;
    if (path === '') {
      return pathname === REDE_PROTO_BASE || pathname === `${REDE_PROTO_BASE}/`;
    }
    return pathname === target || pathname.startsWith(`${target}/`);
  };

  return (
    <Nav>
      {items.map((item) => (
        <NavItem
          key={item.path || 'overview'}
          type="button"
          active={isActive(item.path)}
          onClick={() =>
            navigate(
              item.path ? `${REDE_PROTO_BASE}/${item.path}` : REDE_PROTO_BASE
            )
          }
        >
          {item.label}
        </NavItem>
      ))}
    </Nav>
  );
}
